import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IClientDetailsSchema } from '../types';
import { ClientDetailsRow } from './client-details-row';

const TABLE_HEAD = [
  { id: 'id', label: 'Id', align: 'center', sortable: false },
  { id: 'projectName', label: 'Project Name', align: 'center', sortable: false },
  { id: 'status', label: 'Status', align: 'center' },
  { id: 'managedBy', label: 'Managed By', align: 'center' },
  { id: 'teamMembers', label: 'Team Members', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  data?: IClientDetailsSchema[];
  loading: boolean;
}

const ClientDetailsList = ({ tableProps, data, loading }: Props) => {
  return (
    <PaginatedTable<IClientDetailsSchema>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={data}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => <ClientDetailsRow row={row} />}
    </PaginatedTable>
  );
};

export { ClientDetailsList };
